import {
  AuthMode,
  initialSignInState,
  SignInActions,
  type SignInCredentials
} from 'components/authentication/SignIn'

import type {
  MFAAuthResponse,
  MFAEnabledAuthResponse,
  UserAuthCompany
} from 'types/api/user/session'

type Action =
  | { type: SignInActions.RESET }
  | { type: SignInActions.ENTER_TOKEN; mfaResponse?: MFAEnabledAuthResponse }
  | { type: SignInActions.SELECT_COMPANY; companyList: UserAuthCompany[] }
  | { type: SignInActions.VALIDATE_CREDENTIALS; mfaResponse: MFAAuthResponse }
  | { type: SignInActions.UPDATE_EMAIL; email: string }
  | { type: SignInActions.UPDATE_PASSWORD; password: string }
  | { type: SignInActions.UPDATE_TOKEN; token: string }
  | { type: SignInActions.UPDATE_COMPANY_NAME; companyName: string }

export function signInReducer(
  state: SignInCredentials,
  action: Action
): SignInCredentials {
  switch (action.type) {
    case SignInActions.RESET:
      return { ...initialSignInState }

    case SignInActions.ENTER_TOKEN:
      return { ...state, mode: AuthMode.TOKEN, mfaResponse: null }

    case SignInActions.SELECT_COMPANY:
      return {
        ...state,
        mode: AuthMode.COMPANIES,
        companyList: action.companyList,
        mfaResponse: null
      }

    case SignInActions.VALIDATE_CREDENTIALS:
      return {
        ...state,
        mode: AuthMode.CREDENTIALS,
        mfaResponse: action.mfaResponse
      }

    case SignInActions.UPDATE_EMAIL:
      return { ...state, email: action.email }

    case SignInActions.UPDATE_PASSWORD:
      return { ...state, password: action.password }

    case SignInActions.UPDATE_TOKEN:
      return { ...state, token: action.token }

    case SignInActions.UPDATE_COMPANY_NAME:
      return { ...state, companyName: action.companyName }

    default:
      return state
  }
}
